module.exports = __webpack_public_path__ + "static/media/15.15b68908.jpg";